import {
  Login,
  UseApp,
  SignUp,
  HTSSignUp,
  Handspring,
  HTSProfileSetup,
  ProfileSetup,
  ConfirmEmail,
  ResetPassword,
  ForgotPassword,
  LoginWithToken,
  PaymentRequired,
  SignUpWithPurchase,
  RedirectToDocument,
  SitePersonalization,
} from 'web-auth-containers';

import { urls } from 'web-urls';

import type {
  Route,
} from './privateRoutes';

const initialRoutes: Array<Route> = [
  {
    path: urls.login,
    preload: true,
    component: Login,
  },
  {
    path: urls.useApp,
    preload: true,
    component: UseApp,
  },
  {
    path: urls.getApp,
    options: {
      getApp: true,
    },
    preload: true,
    component: UseApp,
  },
  {
    path: urls.forgotPassword,
    preload: true,
    component: ForgotPassword,
  },
  {
    path: urls.resetPassword,
    preload: true,
    component: ResetPassword,
  },
  {
    path: urls.signup,
    preload: true,
    component: SignUp,
  },
  {
    path: urls.profileSetup,
    preload: true,
    component: ProfileSetup,
  },
  {
    path: urls.sitePersonalization,
    preload: true,
    component: SitePersonalization,
  },
  {
    path: urls.paymentRequired,
    preload: true,
    component: PaymentRequired,
  },
  {
    exact: true,
    path: '/accessToken',
    redirect: urls.login,
  },
  {
    path: '/accessToken/:token/:url?',
    component: LoginWithToken,
  },
  {
    path: '/confirm/:token',
    component: ConfirmEmail,
  },
  {
    path: '/product/:slug',
    component: SignUpWithPurchase,
  },
  {
    path: '/product_plan/:slug',
    options: {
      isPlan: true,
    },
    component: SignUpWithPurchase,
  },
  {
    path: '/test_product/:slug',
    options: {
      isTest: true,
    },
    component: SignUpWithPurchase,
  },
  {
    path: '/test_product_plan/:slug',
    options: {
      isTest: true,
      isPlan: true,
    },
    component: SignUpWithPurchase,
  },
  {
    path: '/view_document/:id',
    component: RedirectToDocument,
  },
  {
    path: '/hts',
    component: HTSSignUp,
  },
  {
    path: '/hts-setup',
    component: HTSProfileSetup,
  },
  {
    path: '/handspring',
    component: Handspring,
  },
];

export default initialRoutes;
